import { formatDateAccordingToTimezoneUsingMoment, generateUUID, GENERIC_STATUS } from "../../../utils/constants"

export function getChatbotChannelConfigurationDataBasedOnChannel(currentActiveStaticWorkflow) {
    let payload = {
        channel_content_type_id: currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment.deployment_channel_content_type_data.channel_content_type_id
    }
    if (currentActiveStaticWorkflow) {
        let deployedChannel = currentActiveStaticWorkflow.chatbot_channel.channel_name.toLowerCase()
        switch (deployedChannel) {
            case 'whatsapp':
                let meta_integration_whatsapp_id = currentActiveStaticWorkflow.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0]?.meta_integration_whatsapp_id ?? null
                let integrated_channel_id = currentActiveStaticWorkflow.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0]?.meta_integration_whatsapp_phone_number_data?.[0]?.integrated_channel_id ?? null
                return {
                    ...payload,
                    meta_integration_whatsapp_id: meta_integration_whatsapp_id,
                    integrated_channel_id: integrated_channel_id
                }
            case 'instagram':
                let meta_integration_instagram_id = currentActiveStaticWorkflow.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0]?.meta_integration_instagram_id ?? null
                let instagram_integrated_channel_id = currentActiveStaticWorkflow.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0]?.integrated_channel_id ?? null
                return {
                    ...payload,
                    meta_integration_instagram_id: meta_integration_instagram_id,
                    integrated_channel_id: instagram_integrated_channel_id
                }
            default:
                return payload;
        }
    }
    return payload
}
export function getChatbotVersionInfo(chatbotDetails, userDetail) {
    let isChatbotPublished = chatbotDetails?.chatbot_version_info?.find((version) => version.chatbot_version_status_name.toLowerCase() == 'published')
    if (isChatbotPublished) {
        return {
            status: "Published",
            lastPublishedTimestamp: formatDateAccordingToTimezoneUsingMoment(isChatbotPublished.timestamp, userDetail?.timezone_hour)
        }
    }
    return {
        status: "Draft"
    }
}
export function isCurrentViewVersionPublished(chatbotDetails) {
    return chatbotDetails?.currentViewVersion?.toLowerCase() === GENERIC_STATUS.PUBLISHED?.toLowerCase();
}

export const exceptionOptions = [
    {
        name: "Reset Workflow",
        id: "c6f7d965-d7b7-460f-88de-52b69bb63628",
        description: "If something goes wrong, restart the workflow from the beginning automatically. Useful for serious or unrecoverable errors."
    },
    {
        name: "Static Error",
        id: "4cfc3ccb-b787-4fb9-831e-14cc8d669ef9",
        description: "Show a custom error message to the user when this step fails. This does not affect the flow; the message is just informative."
    },
    {
        name: "Valid Input Required",
        id: "9d46aadd-0a5a-4ffc-80a7-23aba46a78b8",
        description: "Prevent the user from moving forward unless their input meets the specified condition (e.g., correct format, specific keyword)."
    }
] 

export const emptyStepExceptionObject = (id) => {
    return {
        chatbot_step_exception_id: id, 
        exception_message: "", 
        target_chatbot_step: null, 
        flag_redeploy: false,
        flag_redirect: false, 
        flag_do_nothing: false,
        action_type: "", 
        flag_saved_in_BE: false,
    }
}

export const emptyChatbotExceptionObject = (id) => {
    return {
        chatbot_post_deployment_trigger_id: id, 
        chatbot_post_deployment_trigger_type: {
            chatbot_post_deployment_trigger_type_id: "", 
            chatbot_post_deployment_trigger_type_name: "",
        }, 
        pre_transition_text_message: "", 
        chatbot_step: null,
        flag_redeploy: false,
        flag_redirect: false, 
        flag_do_nothing: false,
        action_type: "", 
        flag_saved_in_BE: false,
    }
}

export const emptyDelayObject = (id, flagStepLevel, stepId) => {
    return {
        chatbot_timeout_trigger_config_id: id, 
        chatbot_step_id: stepId ? stepId : null, 
        condition_group: null, 
        flag_step_level: flagStepLevel, 
        flag_trigger_on_inactivity: false,
        target_chatbot_step_id: "",
        trigger_after_time_ms: 0,
        flag_saved_in_BE: false,
    }
}

export const getExcetionActionType = (flag_redeploy, flag_redirect, flag_do_nothing) => {
    if(flag_redeploy) return "ReDeploy"; 
    if(flag_redirect) return "ReDirect";
    if(flag_do_nothing) return "Do Nothing";
    return "";
}

export function isStaticErrorSelected(value) {
    let staticErrorId = exceptionOptions.find((exception) => exception?.name.toLowerCase() == "static error").id
    if (staticErrorId && value == staticErrorId) {
        return true
    }
    return false;
}
export function getChatbotExceptionMessage(currentActiveStaticWorkflow, flagActionLevel, actionID) {
    if (currentActiveStaticWorkflow) {
        let exceptionType
        let currentActiveIndex = currentActiveStaticWorkflow.chatbot_version_info.findIndex((version) => version.chatbot_version_status_name.toLowerCase() == currentActiveStaticWorkflow.currentViewVersion.toLowerCase()) || 0
        if (flagActionLevel) {
            exceptionType = currentActiveStaticWorkflow?.chatbot_version_info[currentActiveIndex].chatbot_exception.filter((exception) => exception.chatbot_step_action_id == actionID)

        } else {

            exceptionType = currentActiveStaticWorkflow?.chatbot_version_info[currentActiveIndex].chatbot_exception.filter((exception) => !exception.chatbot_step_action_id)
        }
        if (exceptionType?.length > 0) {
            return exceptionType[0]?.chatbot_exception_data[0]?.exception_message
        }
    }
    return "";
}
export function getChatbotExceptionVal(currentActiveStaticWorkflow, flagActionLevel, actionID) {
    if (currentActiveStaticWorkflow) {
        let exceptionType
        let currentActiveIndex = currentActiveStaticWorkflow.chatbot_version_info.findIndex((version) => version.chatbot_version_status_name.toLowerCase() == currentActiveStaticWorkflow.currentViewVersion.toLowerCase()) || 0
        if (flagActionLevel) {
            exceptionType = currentActiveStaticWorkflow?.chatbot_version_info[currentActiveIndex]?.chatbot_exception?.filter((exception) => exception.chatbot_step_action_id == actionID)
        } else {
            exceptionType = currentActiveStaticWorkflow?.chatbot_version_info[currentActiveIndex]?.chatbot_exception?.filter((exception) => !exception.chatbot_step_action_id)
        }
        if (exceptionType?.length > 0) {
            return exceptionType[0].exception_type.exception_type_id
        }
    }
    return null;
}

export const isCarouselTemplateActionType = (actionType) => {
    if(actionType?.toLowerCase() == "send_wa_dm_carousel_template") return true;
    return false;
} 

export const isSendOrderDetailTemplateActionType = (actionType) => {
    if(actionType?.toLowerCase() == "send_order_details_template") return true;
    return false;
}

export const getTemplateDetailsUsedInNode = (currentActiveStaticWorkflow, whatsapp_template_id) => {
    return currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => (template?.whatsapp_template_id ?? "").toString() == (whatsapp_template_id ?? "").toString());
}

export const uniqueChatbotStepFlows = (flows = []) => {
    const seenFlowIds = new Set();
    return flows.filter((flow) => {
        const flowId = flow?.chatbot_step_flow_id;
        if (!flowId || seenFlowIds.has(flowId)) {
            return false;
        }
        seenFlowIds.add(flowId);
        return true;
    });
}

export const mapEdgesToStepFlow = (edges = []) => {
    return uniqueChatbotStepFlows(edges.map((edge) => {
        return {
            chatbot_step_flow_id: edge.id,
            parent_chatbot_step_id: edge.source,
            condition_group: edge.condition_group
        }
    }));
}